'use strict';

// Generated by scripts/gen-irregulars.js — do not edit by hand. Inflectional
// exceptions: the irregular surface->base pairs no suffix rule can reach (ablaut
// verbs, irregular and Latin/Greek plurals, suppletion). morphology.js parses
// this and overlays its curated core on top.
//
// Source: Open English WordNet 2025 noun.exc + verb.exc (https://en-word.net/).
//   Copyright the Open English WordNet contributors, licensed CC BY 4.0
//   (https://creativecommons.org/licenses/by/4.0/) — free to use and
//   redistribute with attribution; the notice rides here and in
//   THIRD-PARTY-NOTICES.

export const WORDNET_IRREGULARS = `
aardwolves aardwolf
abaci abacus
abode abide
abought aby
abscissae abscissa
abye aby
acanthi acanthus
acari acarus
acciaccature acciaccatura
acetabula acetabulum
aciculae acicula
acini acinus
acrefeet acrefoot
acromia acromion
actiniae actinia
actinozoa actinozoan
addenda addendum
addrest address
adenocarcinomata adenocarcinoma
adenomata adenoma
adieux adieu
aecia aecium
agnomina agnomen
agorae agora
aidesdecamp aidedecamp
aidesmemoire aidememoire
alae ala
alewives alewife
alluvia alluvium
altocumuli altocumulus
altostrati altostratus
alulae alula
alumnae alumna
alumni alumnus
alveoli alveolus
am be
amanuenses amanuensis
ambulacra ambulacrum
amebae ameba
amnia amnion
amniocenteses amniocentesis
amoebae amoeba
amoebiases amoebiasis
amoraim amora
amphimixes amphimixis
amphioxi amphioxus
amphisbaenae amphisbaena
amphorae amphora
ampullae ampulla
amygdalae amygdala
anacolutha anacoluthon
analyses analysis
anamneses anamnesis
anamorphoses anamorphosis
anastomoses anastomosis
androecia androecium
andtheridia antheridium
angiomata angioma
animalcula animalculum
anlagen anlage
annuli annulus
antefixa antefix
antennae antenna
antheridia antheridium
anthozoa anthozoan
anthraces anthrax
antisera antiserum
antitheses antithesis
antra antrum
aortae aorta
aphelia aphelion
apices apex
apomixes apomixis
aponeuroses aponeurosis
apophyses apophysis
aposiopeses aposiopesis
apothecia apothecium
apotheoses apotheosis
appendices appendix
appoggiature appoggiatura
apsides apsis
aquae aqua
aquaria aquarium
araglis argali
arboreta arboretum
arcana arcanum
archegonia archegonium
archesporia archesporium
arcked arc
arcking arc
arcsboutants arcboutant
are be
areolae areola
ariette arietta
arisen arise
aristae arista
armamentaria armamentarium
arose arise
artal rotl
artel rotl
arterioscleroses arteriosclerosis
asceses ascesis
asci ascus
aspergilloses aspergillosis
aspersoria aspersorium
assegais assagai
astragali astragalus
asyndeta asyndeton
ate eat
atheromata atheroma
atheroscleroses atherosclerosis
atria atrium
auditoria auditorium
aurae aura
aurar eyrir
auriculae auricula
aurorae aurora
auspices auspex
autocatalyses autocatalysis
automata automaton
autosdafe autodafe
avitaminoses avitaminosis
awoke awake
awoken awake
axes axis
axillae axilla
babysat babysit
bacilli bacillus
backbit backbite
backbitten backbite
backslid backslide
backslidden backslide
bacteriostases bacteriostasis
bade bid
bainsmarie bainmarie
ballistae ballista
bambini bambino
bandeaux bandeau
banditti bandit
bani ban
bases basis
basidia basidium
basileis basileus
bassi basso
beadsmen beadsman
beaten beat
beaux beau
became become
been be
beeves beef
befallen befall
befell befall
began begin
begat beget
begot beget
begotten beget
begun begin
beheld behold
beholden behold
belying belie
bent bend
besought beseech
bespoke bespeak
bespoken bespeak
bestrewn bestrew
bestrid bestride
bestridden bestride
bestrode bestride
bethought bethink
bibliothecae bibliotheca
bicennaries bicentenary
bidden bid
bijoux bijou
bit bite
bitten bite
bivouacked bivouac
bivouacking bivouac
blastemata blastema
blastulae blastula
bled bleed
blest bless
blew blow
blown blow
booklice booklouse
bookshelves bookshelf
boraces borax
bore bear
born bear
borne bear
bought buy
bound bind
brachia brachium
brainchildren brainchild
branchiae branchia
brants brent
bred breed
bregmata bregma
brethren brother
broke break
broken break
bronchi bronchus
brothersinlaw brotherinlaw
brought bring
browbeaten browbeat
bryozoa bryozoan
buckteeth bucktooth
built build
bullae bulla
bureaux bureau
burnt burn
bursae bursa
busses bus
bypast bypass
byssi byssus
cacti cactus
caddying caddie
caducei caduceus
caeca caecum
caesurae caesura
calami calamus
calcanei calcaneus
calces calx
calculi calculus
calli callus
calves calf
calyces calyx
cambia cambium
came come
camerae camera
canaliculi canaliculus
candelabra candelabrum
canthi canthus
capita caput
capitula capitulum
capricci capriccio
carcinomata carcinoma
carides caryatid
carinae carina
carpi carpus
caryopses caryopsis
caryopsides caryopsis
castrati castrato
catalyses catalysis
catenae catena
cathexes cathexis
caudices caudex
caught catch
cavetti cavetto
ceca cecum
cembali cembalo
centesimi centesimo
centra centrum
cercariae cercaria
cercariiae cercaria
cerebella cerebellum
cerebra cerebrum
cervices cervix
chaetae chaeta
chalazae chalaza
challoth hallah
chapeaux chapeau
chateaux chateau
chelae chela
chelicerae chelicera
cherubim cherub
chevauxdefrise chevaldefrise
chevied chivy
chevies chivy
chevying chivy
chiasmata chiasma
chiasmi chiasmus
chid chide
chidden chide
children child
chivvied chivy
chivvies chivy
chivvying chivy
chlamydes chlamys
chondromata chondroma
choragi choragus
chose choose
chosen choose
choux chou
chrysalides chrysalis
cicadae cicada
cicale cicala
cicatrices cicatrix
ciceroni cicerone
cilia cilium
cineraria cinerarium
cingula cingulum
cirri cirrus
cirrocumuli cirrocumulus
cirrostrati cirrostratus
cisternae cisterna
clad clothe
cleft cleave
clepsydrae clepsydra
cloacae cloaca
clostridia clostridium
clove cleave
cloven cleave
cloverleaves cloverleaf
clung cling
clypei clypeus
coagula coagulum
cocci coccus
coccyges coccyx
cochleae cochlea
codices codex
coelentera coelenteron
cognomina cognomen
cola colon
colloquia colloquium
collyria collyrium
colossi colossus
columbaria columbarium
columellae columella
comae coma
comedones comedo
concerti concerto
conchae concha
confervae conferva
congii congius
conidia conidium
conjunctivae conjunctiva
consortia consortium
continua continuum
contralti contralto
convolvuli convolvulus
copulae copula
coria corium
corneae cornea
cornua cornu
coronae corona
corpora corpus
corrigenda corrigendum
cortices cortex
cortinae cortina
costae costa
countersank countersink
countersunk countersink
coxae coxa
crania cranium
credenda credendum
crematoria crematorium
crept creep
crescendi crescendo
crises crisis
criteria criterion
crossbred crossbreed
cruces crux
crura crus
cryings cry
ctenidia ctenidium
culti cultus
cumuli cumulus
cumulonimbi cumulonimbus
curricula curriculum
curst curse
cutes cutis
cuticulae cuticula
cyclopes cyclops
cycloses cyclosis
cylices cylix
cylikes cylix
cymae cyma
cymatia cymatium
data datum
daughtersinlaw daughterinlaw
dealt deal
decennia decennium
deciduae decidua
degasses degas
delphinia delphinium
dermatoses dermatosis
desiderata desideratum
diaereses diaeresis
diaerses diaeresis
diagnoses diagnosis
dialyses dialysis
diaphyses diaphysis
diarthroses diarthrosis
diastases diastasis
diastemata diastema
diathses diathesis
dibbukkim dibbuk
dicta dictum
did do
diereses dieresis
dieses diesis
differentiae differentia
dilettanti dilettante
diplococci diplococcus
disci discus
dive diva
diverticula diverticulum
divertimenti divertimento
djinn djinni
dogmata dogma
dogteeth dogtooth
domatia domatium
done do
dormice dormouse
dorsa dorsum
dove dive
drachmae drachma
drank drink
drawknives drawknife
drawn draw
dreamt dream
drew draw
driven drive
drosophilae drosophila
drove drive
drunk drink
dug dig
dui duo
duodena duodenum
dwarves dwarf
dwelt dwell
dybbukkim dybbuk
dying die
eaten eat
ecchymoses ecchymosis
ecdyses ecdysis
echidnae echidna
echini echinus
echinococci echinococcus
ectozoa ectozoan
edemata edema
effluvia effluvium
eisegeses eisegesis
eisteddfodau eisteddfod
ellipses ellipsis
elves elf
elytra elytron
emboli embolus
emphases emphasis
emporia emporium
enarthroses enarthrosis
encephala encephalon
encephalitides encephalitis
enchiridia enchiridion
enchondromata enchondroma
encomia encomium
endamebae endameba
endocardia endocardium
endocrania endocranium
endometria endometrium
endostea endosteum
endothelia endothelium
endozoa endozoan
enemata enema
entases entasis
entera enteron
entozoa entozoan
epentheses epenthesis
ephemera ephemeron
ephemerae ephemera
ephemerides ephemeris
epicalyces epicalyx
epicanthi epicanthus
epicardia epicardium
epididymides epididymis
epigastria epigastrium
epiglottides epiglottis
epiphenomena epiphenomenon
epiphyses epiphysis
epithalamia epithalamium
epithelia epithelium
epitheliomata epithelioma
epizoa epizoan
equilibria equilibrium
errata erratum
esophagi esophagus
etyma etymon
eucalypti eucalyptus
exanthemata exanthema
executrices executrix
exegeses exegesis
exordia exordium
exostoses exostosis
extrema extremum
eyeteeth eyetooth
faciae facia
faculae facula
fallen fall
famuli famulus
fasciae fascia
fasciculi fasciculus
fathersinlaw fatherinlaw
faunae fauna
feculae fecula
fed feed
feet foot
fell fall
fellaheen fellah
fellahin fellah
felt feel
femora femur
fenestellae fenestella
fenestrae fenestra
feriae feria
fermate fermata
festschriften festschrift
fezzes fez
fibromata fibroma
fibulae fibula
fieldmice fieldmouse
fila filum
filariiae filaria
fimbriae fimbria
fishwives fishwife
fistulae fistula
flagella flagellum
flagstaves flagstaff
flambeaux flambeau
flamines flamen
flatfeet flatfoot
fled flee
fleursdelis fleurdelis
fleursdelys fleurdelys
flew fly
floodlit floodlight
florae flora
florilegia florilegium
flown fly
flung fling
flyleaves flyleaf
foci focus
folia folium
fora forum
foramina foramen
forbad forbid
forbade forbid
forbidden forbid
forbore forbear
forborne forbear
forcefed forcefeed
forefeet forefoot
foregone forego
foreknew foreknow
foreknown foreknow
foresaw foresee
foreseen foresee
foreshown foreshow
foretold foretell
forewent forego
forgave forgive
forgiven forgive
forgone forgo
forgot forget
forgotten forget
formulae formula
fornices fornix
forsaken forsake
forsook forsake
forswore forswear
forsworn forswear
forwent forgo
fossae fossa
fought fight
found find
foveae fovea
fricandeaux fricandeau
frolicked frolic
frolicking frolic
froze freeze
frozen freeze
frusta frustum
fuci fucus
fulcra fulcrum
fundi fundus
fungi fungus
funiculi funiculus
furculae furcula
gainsaid gainsay
galeae galea
gametangia gametangium
gametoecia gametoecium
gan gin
ganglia ganglion
gasses gas
gastrulae gastrula
gateaux gateau
gave give
geese goose
gelt geld
gemboks gemsbok
gembucks gemsbuck
gemmae gemma
genera genus
geneses genesis
genii genius
gentes gens
gentlemenatarms gentlemanatarms
genua genu
gestalten gestalt
ghostwritten ghostwrite
ghostwrote ghostwrite
gilt gild
gingivae gingiva
ginglymi ginglymus
girt gird
given give
glabellae glabella
gladioli gladiolus
glandes glans
gliomata glioma
glissandi glissando
globigerinae globigerina
glochidcia glochidium
glochidia glochidium
glomeruli glomerulus
glossae glossa
glottides glottis
glutei gluteus
gnawn gnaw
gnoses gnosis
godchildren godchild
goingsover goingover
gone go
gonia gonion
gonococci gonococcus
got get
gotten get
goyim goy
graffiti graffito
grandchildren grandchild
grantsinaid grantinaid
granulomata granuloma
graven grave
grew grow
gript grip
groszy grosz
ground grind
grown grow
gummata gumma
gymnasia gymnasium
gynoecea gynoecium
gynoecia gynoecium
gyri gyrus
had have
haematolyses haematolysis
haematomata haematoma
haemodialyses haemodialysis
haemolyses haemolysis
haemoptyses haemoptysis
haleru haler
halfpence halfpenny
hallot hallah
halloth hallah
halluces hallux
halves half
hamstrung hamstring
hangerson hangeron
has have
haustoria haustorium
heard hear
heirsatlaw heiratlaw
held hold
helices helix
heliozoa heliozoan
hematolyses hematolysis
hematomata hematoma
hemodialyses hemodialysis
hemolyses hemolysis
hemoptyses hemoptysis
herbaria herbarium
hermae herm
herniae hernia
hewn hew
hid hide
hidden hide
hila hilum
hili hilus
hippocampi hippocampus
hippopotami hippopotamus
homunculi homunculus
honied honey
honoraria honorarium
hooves hoof
housewives housewife
hove heave
humeri humerus
hung hang
hydrae hydra
hydrozoa hydrozoan
hymenia hymenium
hymenoptera hymenopteran
hypanthia hypanthium
hyphae hypha
hypnoses hypnosis
hypochondria hypochondrium
hypophyses hypophysis
hypostases hypostasis
hypothalami hypothalamus
hypotheses hypothesis
hyraces hyrax
iambi iamb
ibices ibex
ichthyosauri ichthyosaurus
ichthyosauruses ichthyosaur
icosahedra icosahedron
ilia ilium
imagines imago
imperia imperium
incubi incubus
incudes incus
indices index
indumenta indumentum
indusia indusium
indwelt indwell
infundibula infundibulum
inlaid inlay
inocula inoculum
intagli intaglio
interbred interbreed
interleaves interleaf
intermezzi intermezzo
interregna interregnum
interwove interweave
interwoven interweave
intimae intima
involucra involucre
inwove inweave
inwoven inweave
irides iris
is be
ischia ischium
isthmi isthmus
jackknives jackknife
jacksinthebox jackinthebox
jambeaux jambeau
jinn jinni
keeshonden keeshond
kept keep
kibbutzim kibbutz
knelt kneel
knew know
knives knife
known know
kronen krone
kroner krone
kronur krona
krooni kroon
kylikes kylix
labia labium
lactobacilli lactobacillus
lacunae lacuna
lacunaria lacunar
laden lade
ladiesinwaiting ladyinwaiting
laid lay
lain lie
lamellae lamella
lamiae lamia
laminae lamina
larvae larva
larynges larynx
lati lat
latices latex
latu lat
lay lie
leant lean
leapt leap
learnt learn
leaves leaf
led lead
left leave
lei leu
lemmata lemma
lemnisci lemniscus
lent lend
lentigines lentigo
lepidoptera lepidopteran
lepta lepton
leptocephali leptocephalus
leucocytozoa leucocytozoan
leva lev
libretti libretto
lice louse
lieder lied
limbi limbus
limina limen
linguae lingua
lipomata lipoma
lire lira
lisente sente
listente sente
lit light
litai lit
litu litas
lives life
loaves loaf
loci locus
loculi loculus
loggie loggia
logia logion
loricae lorica
lost lose
loupsgarous loupgarou
lumbi lumbus
lumina lumen
lunulae lunula
lustra lustre
lying lie
lyingsin lyingin
lymphangitides lymphangitis
lymphomata lymphoma
lymphopoieses lymphopoiesis
lyses lysis
maare maar
macrosporangia macrosporangium
maculae macula
made make
madornos madrono
maestri maestro
mafiosi mafioso
magi magus
magmata magma
makuta likuta
mallei malleus
maloti loti
mamillae mamilla
mammae mamma
mammillae mammilla
mantes mantis
manubria manubrium
markkaa markka
marsupia marsupium
mastersatarms masteratarms
matrices matrix
matzoth matzo
mausolea mausoleum
maxillae maxilla
maxima maximum
meant mean
media medium
mediastina mediastinum
medullae medulla
medusae medusa
megasporangia megasporangium
megilloth megillah
meioses meiosis
melanomata melanoma
memoranda memorandum
men man
menatarms manatarms
menisci meniscus
menofwar manofwar
menowar manofwar
menservants manservant
menstrua menstruum
mesdames madame
mesdemoiselles mademoiselle
met meet
metacarpi metacarpus
metamorphoses metamorphosis
metastases metastasis
metatarsi metatarsus
metatheses metathesis
metazoa metazoan
metempsychoses metempsychosis
metencephala metencephalon
mezuzoth mezuzah
miasmata miasma
mice mouse
microsporangia microsporangium
midwives midwife
milia milium
milieux milieu
millennia millennium
mimicked mimic
mimicking mimic
minae mina
minima minimum
minutiae minutia
minyanim minyan
mioses miosis
misdealt misdeal
misgave misgive
misgiven misgive
mislaid mislay
misled mislead
misspelt misspell
misspent misspend
mistaken mistake
mistook mistake
misunderstood misunderstand
mitochondria mitochondrion
mitzvoth mitzvah
modioli modiolus
moduli modulus
molten melt
momenta momentum
monades monas
moratoria moratorium
morceaux morceau
morphallaxes morphallaxis
morulae morula
moshavim moshav
mothersinlaw motherinlaw
mown mow
mucosae mucosa
muskallunge muskellunge
mycelia mycelium
mycobacteria mycobacterium
myelencephala myelencephalon
myiases myiasis
myocardia myocardium
myofibrillae myofibrilla
myomata myoma
myoses myosis
myxomata myxoma
narcissi narcissus
nares naris
nasopharynges nasopharynx
natatoria natatorium
naumachiae naumachia
nautili nautilus
nebulae nebula
necropoleis necropolis
nemeses nemesis
neurohypophyses neurohypophysis
neuromata neuroma
neuroptera neuropteron
neuroses neurosis
nevi nevus
nidi nidus
nimbi nimbus
noctilucae noctiluca
nonplusses nonplus
noumena noumenon
novae nova
novelle novella
novenae novena
nucelli nucellus
nuchae nucha
nuclei nucleus
nucleoli nucleolus
nulliparae nullipara
numina numen
oases oasis
obligati obligato
oboli obolus
occipita occiput
ocelli ocellus
octahedra octahedron
octopi octopus
oculi oculus
oedemata edema
oesophagi esophagus
oldwives oldwife
omasa omasum
omenta omentum
ommatidia ommatidium
onagri onager
opercula operculum
optima optimum
ora os
organa organon
orthoptera orthopteron
osar os
ossa os
osteomata osteoma
outbidden outbid
outdid outdo
outdone outdo
outdrawn outdraw
outdrew outdraw
outfought outfight
outgone outgo
outgrew outgrow
outgrown outgrow
outran outrun
outridden outride
outrode outride
outshone outshine
outsold outsell
outwent outgo
outwore outwear
outworn outwear
ova ovum
overbidden overbid
overbore overbear
overborne overbear
overcame overcome
overdid overdo
overdone overdo
overdrawn overdraw
overdrew overdraw
overdriven overdrive
overdrove overdrive
overflew overfly
overflown overflow
overgrew overgrow
overgrown overgrow
overheard overhear
overhung overhang
overlaid overlay
overlain overlie
overlay overlie
overlying overlie
overpaid overpay
overran overrun
overridden override
overrode override
oversaw oversee
overseen oversee
oversewn oversew
overshot overshoot
overslept oversleep
overspent overspend
overtaken overtake
overthrew overthrow
overthrown overthrow
overtook overtake
overwritten overwrite
overwrote overwrite
ovoli ovolo
ovotestes ovotestis
oxen ox
oxymora oxymoron
paid pay
paise paisa
palestrae palestra
palingeneses palingenesis
pallia pallium
panicked panic
panicking panic
paparazzi paparazzo
paperknives paperknife
papillae papilla
papillomata papilloma
pappi pappus
papyri papyrus
paraleipses paraleipsis
paralyses paralysis
paramecia paramecium
paraphyses paraphysis
parapodia parapodium
parapraxes parapraxis
parazoa parazoan
parentheses parenthesis
parhelia parhelion
parietes paries
partaken partake
partook partake
passersby passerby
pastorali pastorale
patellae patella
patinae patina
patresfamilias paterfamilias
pease pea
pedes pes
pelves pelvis
pence penny
penes penis
penetralia penetralium
penknives penknife
pennia penni
pent pen
pentahedra pentahedron
pentimenti pentimento
penumbrae penumbra
pepla peplum
pericardia pericardium
peridia peridium
perigonia perigonium
perihelia perihelion
perinea perineum
periostea periosteum
periphrases periphrasis
peristalses peristalsis
perithecia perithecium
peritonea peritoneum
personae persona
petechiae petechia
pfennige pfennig
phalanges phalanx
phalli phallus
pharynges pharynx
phenomena phenomenon
philodendra philodendron
phyla phylum
phylae phyle
phylogeneses phylogenesis
picnicked picnic
picnicking picnic
piedsaterre piedaterre
pilei pileus
pineta pinetum
pinnae pinna
placentae placenta
planetaria planetarium
planulae planula
plasmodia plasmodium
plateaux plateau
plectra plectron
pled plead
plena plenum
pleurae pleura
plicae plica
ploughmen ploughman
pneumococci pneumococcus
pocketknives pocketknife
podetia podetium
podia podium
pollices pollex
pollinia pollinium
polyhedra polyhedron
polypi polypus
polyzoa polyzoan
pontes pons
pontifices pontifex
portmanteaux portmanteau
praenomina praenomen
praxes praxis
prepaid prepay
primi primo
primigravidae primigravida
primiparae primipara
primordia primordium
proboscides proboscis
prognoses prognosis
programmes program
prolegomena prolegomenon
prolepses prolepsis
promycelia promycelium
pronuclei pronucleus
propositi propositus
proscenia proscenium
prosencephala prosencephalon
prostheses prosthesis
prothalamia prothalamion
prothoraces prothorax
protozoa protozoan
proven prove
psalteria psalterium
pseudopodia pseudopodium
psychoneuroses psychoneurosis
psychoses psychosis
pterygia pterygium
ptoses ptosis
pubes pubis
pudenda pudendum
puli pul
pupae pupa
putamina putamen
pycnidia pycnidium
pylori pylorus
pyxides pyxis
pyxidia pyxidium
quadrennia quadrennium
quanta quantum
quarterstaves quarterstaff
quickfroze quickfreeze
quickfrozen quickfreeze
quinquennia quinquennium
quizzes quiz
rabatos rebato
radices radix
radii radius
rami ramus
ran run
rang ring
ranulae ranula
raphae raphe
rebuilt rebuild
recta rectum
recti rectus
redid redo
redone redo
referenda referendum
reft reave
reheard rehear
reis real
relata relatum
remade remake
rent rend
repaid repay
reran rerun
reseaux reseau
resewn resew
residua residuum
retaken retake
rethought rethink
retia rete
reticula reticulum
retinae retina
retold retell
retook retake
rewound rewind
rewritten rewrite
rewrote rewrite
rhabdomyomata rhabdomyoma
rhachises rachis
rhinencephala rhinencephalon
rhombi rhombus
rhonchi rhonchus
rickettsiae rickettsia
ridden ride
rilievi rilievo
rimae rima
risen rise
riven rive
robesdechambre robedechambre
rode ride
rondeaux rondeau
rose rise
rostra rostrum
roughhewn roughhew
rouleaux rouleau
rove reeve
rugae ruga
rumina rumen
rung ring
runnersup runnerup
sacra sacrum
saguaros sahuaro
said say
salespeople salesperson
salmonellae salmonella
salpae salpa
salpinges salpinx
sancta sanctum
sang sing
sanitaria sanitarium
sank sink
santimi santims
sarcophagi sarcophagus
sartorii sartorius
sat sit
saw see
sawn saw
scaleni scalenus
scapulae scapula
scarabaei scarabaeus
scarves scarf
schemata schema
scherzi scherzo
scholia scholium
scleroses sclerosis
sclerotia sclerotium
scoriae scoria
scotomata scotoma
scriptoria scriptorium
scrota scrotum
scyphi scyphus
scyphozoa scyphozoan
secondi secondo
seen see
segni segno
selves self
sent send
senti sent
separatrices separatrix
septa septum
sequelae sequela
sera serum
seraphim seraph
setae seta
sewn sew
sgraffiti sgraffito
shaken shake
shat shit
shaven shave
sheaves sheaf
shellacked shellac
shellacking shellac
shelves shelf
shewn shew
shinleaves shinleaf
shittim shittah
shod shoe
shofroth shofar
shone shine
shook shake
shophroth shophar
shot shoot
shown show
shrank shrink
shrewmice shrewmouse
shriven shrive
shrove shrive
shrunk shrink
shrunken shrink
sicked sic
sicking sic
sightsaw sightsee
sightseen sightsee
signore signora
signori signior
signorine signorina
siliquae siliqua
silvae silva
simulacra simulacrum
sincipita sinciput
sistersinlaw sisterinlaw
skid ski
skydove skydive
slain slay
slept sleep
slew slay
slid slide
slidden slide
slung sling
slunk slink
smelt smell
smit smite
smitten smite
smote smite
snuck sneak
solaria solarium
sold sell
solfeggi solfeggio
soli solo
solidi solidus
somata soma
sonsinlaw soninlaw
soprani soprano
sordini sordino
sori sorus
sought seek
sown sow
spadices spadix
spat spit
spectra spectrum
specula speculum
sped speed
spellbound spellbind
spelt spell
spent spend
spermatozoa spermatozoon
sphinges sphinx
spicula spiculum
spilt spill
spirilla spirillum
splayfeet splayfoot
splenii splenius
spoilt spoil
spoke speak
spoken speak
sporangia sporangium
sporozoa sporozoan
spotlit spotlight
sprang spring
sprung spring
spun spin
sputa sputum
squamae squama
squilgee squeegee
squillae squilla
stadia stadium
stamina stamen
stank stink
stapedes stapes
staphylococci staphylococcus
staretsy starets
startsy starets
stelae stele
stemmata stemma
stenoses stenosis
stepchildren stepchild
sterna sternum
stigmata stigma
stimuli stimulus
stole steal
stolen steal
stomata stoma
stood stand
stotinki stotinka
stotkini stotinka
stove stave
strata stratum
strati stratus
streptococci streptococcus
strewn strew
striae stria
stridden stride
striven strive
strobili strobilus
strode stride
stromata stroma
strove strive
struck strike
strumae struma
strung string
stuck stick
stung sting
stunk stink
styli stylus
stylopodia stylopodium
stymying stymie
subgenera subgenus
submucosae submucosa
subphyla subphylum
substrata substratum
succedanea succedaneum
succubi succubus
sudatoria sudatorium
sulci sulcus
sung sing
sunk sink
sunken sink
supernovae supernova
superstrata superstratum
swam swim
swept sweep
swollen swell
swopped swap
swopping swap
swops swap
swore swear
sworn swear
swum swim
swung swing
syconia syconium
syllabi syllabus
syllepses syllepsis
symphyses symphysis
symposia symposium
synapses synapsis
syncytia syncytium
synopses synopsis
syntagmata syntagma
syntheses synthesis
syringes syrinx
tableaux tableau
taeniae taenia
taken take
talcked talc
talcking talc
tali talus
tallaisim tallith
tallitoth tallith
tarantulae tarantula
tarsi tarsus
taught teach
taxa taxon
taxes taxis
taxying taxi
teeth tooth
tempi tempo
tenderfeet tenderfoot
teniae tenia
terata teras
teredines teredo
termini terminus
terraria terrarium
terzetti terzetto
tesserae tessera
testae testa
testes testis
testudines testudo
tetrahedra tetrahedron
tetraskelia tetraskelion
thalami thalamus
thalli thallus
thecae theca
therses thyrse
thesauri thesaurus
theses thesis
thieves thief
thoraces thorax
thought think
threw throw
thriven thrive
thrombi thrombus
throve thrive
thrown throw
thymi thymus
thyrsi thyrsus
tibiae tibia
titmice titmouse
told tell
tomenta tomentum
took take
tophi tophus
topoi topos
tore tear
tori torus
torn tear
torsi torso
touracos turaco
trabeculae trabecula
tracheae trachea
trafficked traffic
trafficking traffic
tragi tragus
trameled trammel
trameling trammel
tramelled trammel
tramelling trammel
tramels trammel
transfixt transfix
tranship transship
trapezia trapezium
trapezohedra trapezohedron
traumata trauma
treponemata treponema
trichinae trichina
triclinia triclinium
triskelia triskelion
triumviri triumvir
trivia trivium
trod tread
trodden tread
trousdeloup troudeloup
trousseaux trousseau
tubae tuba
turves turf
tying tie
tympana tympanum
typewritten typewrite
typewrote typewrite
tyros tiro
ulnae ulna
ultimata ultimatum
umbilici umbilicus
umbones umbo
umbrae umbra
unbent unbend
unbound unbind
unci uncus
unclad unclothe
undergirt undergird
undergone undergo
underlaid underlay
underlain underlie
underlay underlie
underlying underlie
underpaid underpay
undershot undershoot
undersold undersell
understood understand
undertaken undertake
undertook undertake
underwent undergo
underwritten underwrite
underwrote underwrite
undid undo
undone undo
unfroze unfreeze
unfrozen unfreeze
unlearnt unlearn
unmade unmake
unsaid unsay
unstrung unstring
untaught unteach
untying untie
unwound unwind
upheld uphold
uphove upheave
uprisen uprise
uprose uprise
urethrae urethra
urinalyses urinalysis
uteri uterus
utriculi utriculus
uvulae uvula
vacua vacuum
vagi vagus
vaginae vagina
valleculae vallecula
varices varix
vasa vas
vela velum
venae vena
ventriculi ventriculus
vermes vermis
verrucae verruca
vertebrae vertebra
vertices vertex
vertigines vertigo
vesicae vesica
vibrissae vibrissa
villi villus
virtuosi virtuoso
vitelli vitellus
vivaria vivarium
voces vox
volvae volva
vorticellae vorticella
vortices vortex
vulvae vulva
vying vie
wagonslits wagonlit
was be
waylaid waylay
went go
wept weep
were be
werewolves werewolf
wharves wharf
whippersin whipperin
whipsawn whipsaw
whizzes whiz
withdrawn withdraw
withdrew withdraw
withheld withhold
withstood withstand
wives wife
woke wake
woken wake
wolves wolf
won win
woodlice woodlouse
wore wear
worn wear
wound wind
wove weave
woven weave
written write
wrote write
wrought work
wrung wring
yeshivahs yeshiva
yeshivoth yeshiva
yogin yogi
zoonoses zoonosis
`;
